import { ExtendedDistrict } from '@bpd-library/utilities';

import { translateItem, useTranslate } from '../../hooks';
import { FormattedStatus } from './status';

/**
 * @description Returns the translated district status as Text element and color
 * @param {ExtendedProjectPhase} projectPhase
 * @return {*}  {(FormattedStatus | undefined)}
 */
const formatDistrictStatus = (district: ExtendedDistrict): FormattedStatus | undefined => {
    const { status } = district;

    switch (status) {
        case 'InPreparation':
            return {
                label: useTranslate('StatusLabel-InVoorbereiding'),
                color: 'grey',
            };
        case 'OnSale':
            return {
                label: useTranslate('StatusLabel-InVerkoop'),
                color: 'green',
            };
        case 'Sold':
            return {
                label: useTranslate('Enum-ConstructionNumberStatus-Verkocht'),
                color: 'red',
            };
        case 'ForRent':
            return {
                label: useTranslate('Enum-ProjectStatus-InVerhuur'),
                color: 'green',
            };
        case 'Rented':
            return {
                label: useTranslate('Enum-ProjectStatus-Verhuurd'),
                color: 'red',
            };
    }

    return;
};

/**
 * @description Returns the translated district status as a string and color
 * @param {ExtendedDistrict} district
 * @return {*}  {(Promise<FormattedStatus | undefined>)}
 */
const formatDistrictStatusAsync = async (
    district: ExtendedDistrict,
): Promise<FormattedStatus | undefined> => {
    const { status } = district;

    switch (status) {
        case 'InPreparation':
            return {
                label: await translateItem('StatusLabel-InVoorbereiding'),
                color: 'grey',
            };
        case 'OnSale':
            return {
                label: await translateItem('StatusLabel-InVerkoop'),
                color: 'green',
            };
        case 'Sold':
            return {
                label: await translateItem('Enum-ConstructionNumberStatus-Verkocht'),
                color: 'red',
            };
        case 'ForRent':
            return {
                label: await translateItem('Enum-ProjectStatus-InVerhuur'),
                color: 'green',
            };
        case 'Rented':
            return {
                label: await translateItem('Enum-ProjectStatus-Verhuurd'),
                color: 'red',
            };
    }

    return;
};

export { formatDistrictStatus, formatDistrictStatusAsync };
